import { render, staticRenderFns } from "./DocumentsHelp.vue?vue&type=template&id=209200a4&scoped=true"
import script from "./DocumentsHelp.vue?vue&type=script&lang=js"
export * from "./DocumentsHelp.vue?vue&type=script&lang=js"
import style0 from "./DocumentsHelp.vue?vue&type=style&index=0&id=209200a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209200a4",
  null
  
)

export default component.exports